/**
 * Utility for storing user preferences for UserCell display mode
 */

const STORAGE_KEY = 'user-cell-view-preference';

export type UserCellViewMode = 'compact' | 'full';

export interface UserCellPreference {
  viewMode: UserCellViewMode;
  savedAt: string;
}

/**
 * Save user preference for UserCell view mode
 */
export const saveUserCellPreference = (viewMode: UserCellViewMode): void => {
  try {
    const preference: UserCellPreference = {
      viewMode,
      savedAt: new Date().toISOString(),
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(preference));
  } catch (error) {
    console.error('Failed to save UserCell preference:', error);
  }
};

/**
 * Load user preference for UserCell view mode
 * Returns 'compact' as default if no preference is saved
 */
export const loadUserCellPreference = (): UserCellViewMode => {
  try {
    const preference = localStorage.getItem(STORAGE_KEY);

    if (preference) {
      const parsed: UserCellPreference = JSON.parse(preference);
      return parsed.viewMode;
    }

    return 'compact'; // Default to compact view
  } catch (error) {
    console.error('Failed to load UserCell preference:', error);
    return 'compact'; // Default to compact view on error
  }
};

/**
 * Clear saved preference
 */
export const clearUserCellPreference = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear UserCell preference:', error);
  }
};

